import { type ComponentProps } from 'react'
import { Dialog as BaseDialog } from '@base-ui/react/dialog'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface DialogTitleProps extends PartProps<ComponentProps<typeof BaseDialog.Title>> {
  className?: string
}

export function DialogTitle({ className, children, ...props }: DialogTitleProps) {
  return (
    <BaseDialog.Title className={twMerge('text-foreground type-ui-lg font-semibold', className)} {...props}>
      {children}
    </BaseDialog.Title>
  )
}
